import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'appBuildInfo';
const POLLING_INTERVAL = 120000; // 2 minutos para TopBar (más espaciado que UpdateNotification)

/**
 * Hook para detectar si hay una actualización disponible
 * Compara build-info.json del servidor vs localStorage
 */
export const useUpdateAvailable = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [buildInfo, setBuildInfo] = useState(null);

  const fetchBuildInfo = useCallback(async () => {
    try {
      const response = await fetch(`/build-info.json?t=${Date.now()}`, {
        cache: 'no-store'
      });
      
      if (!response.ok) {
        return null;
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error al cargar build-info.json:', error);
      return null;
    }
  }, []);

  const checkForUpdates = useCallback(async () => {
    const serverBuildInfo = await fetchBuildInfo();
    
    if (!serverBuildInfo) {
      return;
    }

    const storedBuildInfoStr = localStorage.getItem(STORAGE_KEY);
    
    if (!storedBuildInfoStr) {
      return;
    }

    try {
      const storedBuildInfo = JSON.parse(storedBuildInfoStr);
      
      const timestampDiff = serverBuildInfo.timestamp !== storedBuildInfo.timestamp;
      const versionDiff = serverBuildInfo.version !== storedBuildInfo.version;
      
      if (timestampDiff || versionDiff) {
        setBuildInfo(serverBuildInfo);
        setUpdateAvailable(true);
      } else {
        setUpdateAvailable(false);
      }
    } catch (error) {
      console.error('Error al parsear build-info almacenado:', error);
    }
  }, [fetchBuildInfo]);

  useEffect(() => {
    // Verificar al montar
    checkForUpdates();

    // Polling periódico
    const interval = setInterval(() => {
      checkForUpdates();
    }, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [checkForUpdates]);

  const handleUpdate = () => {
    if (buildInfo) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(buildInfo));
    }
    window.location.reload();
  };

  return { updateAvailable, buildInfo, handleUpdate };
};


